import React, { useEffect, useMemo, useState } from "react";
import TableContainer from "../../components/Common/TableContainer";
import Breadcrumb from "../../components/Common/Breadcrumb";
import { Card, CardBody, Button, Container } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { getRecords, uploadExelFile } from "../../services/api.service";
import { exportPageData } from "./InvoiceFile";
import ModernPopup from "../../services/popup/Popup";

const breadcrumbItems = [];

const InvoicetList = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [exportData, setExportData] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [popupData, setPopupData] = useState({
    isOpen: false,
    message: "",
    isError: false,
  });

  useEffect(() => {
    getData();
  }, [searchKeyword, page, pageSize, selectedFile]);

  useEffect(() => {
    const projectId = JSON.parse(localStorage?.getItem("projectID"));
    handleExportData(projectId);
  }, []);
  const getData = async () => {
    const projectId = JSON.parse(localStorage?.getItem("projectID"));
    try {
      const payload = {
        modelName: "invoices",
        whereCondition: {
          project_id: projectId,
        },
        relations: [
          {
            module: "invoice_order_items",
            moduleAs: "invoice_order_items",
            subModule: "item_masters",
            subModuleAs: "item",
            subSubModule: "uom_masters",
            subSubModuleAs: "uom",
          },
          {
            module: "projects",
            moduleAs: "project",
          },
          {
            module: "orders",
            moduleAs: "order",
          },
        ],
        search: {
          searchKeyword: searchKeyword,
          field_name: [
            "invoice_no",
            "remark",
            "project.project_code",
            "project.project_name",
            "order.order_no",
          ],
        },
        pagination: {
          page: page + 1,
          pageSize: pageSize,
        },
      };

      const responseData = await getRecords(payload, "/listInvoice");

      responseData.data.forEach((element, index) => {
        element.index = index + 1;
      });
      setTotalCount(responseData.count);

      const sortedData = responseData.data.sort((a, b) => b.index - a.index);
      setData(sortedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClickAdd = () => {
    navigate("/invoice-create");
  };
  const handleEditClick = (id) => {
    navigate(`/invoice-create/${id}`);
  };
  const handleViewClick = (id) => {
    navigate(`/invoice-view/${id}`);
  };

  const getSearchInputData = (inputValue) => {
    setSearchKeyword(inputValue);
  };

  const nextToPages = () => {
    setPage(page + 1);
  };

  const previousToPages = () => {
    setPage(page - 1);
  };

  const handlePageSizeChange = (data) => {
    setPageSize(data);
    const newTotalPages = Math.ceil(totalCount / data);
    if (page >= newTotalPages) {
      setPage(0);
    }
  };

  const lastToPages = () => {
    setPage(Math.ceil(totalCount / pageSize) - 1);
  };

  const previousFirstToPages = () => {
    setPage(0);
  };

  const handleExportData = async (projectId) => {
    try {
      exportPageData.data.whereCondition = {
        project_id: projectId,
      };
      const responseData = await getRecords(
        exportPageData?.data,
        "/getRecords"
      );
      if (responseData?.data.length == 0) setExportData([]);
      const exportData = responseData?.data.map((item, index) => ({
        "SR. NO": index + 1,
        PROJECT: item?.project?.project_name || "-",
        "SO No": item?.order.order_no || "-",
        "INVOICE NO": item?.invoice_no || "-",
        REMARK: item?.remark || "-",
        "INVOICE STATUS": item?.status?.split("_").join(" "),
        STATUS:
          item?.is_active === false || item?.is_active === 0
            ? "In-active"
            : "Active",
      }));
      setExportData(exportData);
    } catch (error) {
      console.error("Error fetching records:", error);
    }
  };
  const columns = useMemo(
    () => [
      {
        Header: "SR.NO",
        accessor: "index",
        accessor: (row) => page * pageSize + row.index,
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "50px" }}>{value}</div>,
      },

      {
        Header: "PROJECT",
        accessor: (row) =>
          row.project && row.project.project_name
            ? row.project.project_name
            : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },

      {
        Header: "SO No",
        accessor: (row) =>
          row?.order?.order_no && row?.order?.order_no
            ? row?.order?.order_no
            : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "100px" }}>{value}</div>,
      },

      {
        Header: "INVOICE NO",
        accessor: (row) =>
          row.invoice_no && row.invoice_no ? row.invoice_no : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "100px" }}>{value}</div>,
      },

      {
        Header: "REMARK",
        accessor: (row) => (row && row?.remark ? row?.remark : "-"),
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },
      {
        Header: "INVOICE STATUS",
        accessor: (row) => (
          <span className="badge bg-success-subtle text-success text-uppercase">
            {row?.status?.split("_").join(" ")}
          </span>
        ),
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "180px" }}>{value}</div>,
      },

      {
        Header: "STATUS",
        accessor: "is_active",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => (
          <div style={{ width: "100px" }}>
            {value === false || value === 0 ? (
              <span className="badge bg-danger-subtle text-danger text-uppercase">
                In-active
              </span>
            ) : (
              <span className="badge bg-success-subtle text-success text-uppercase">
                Active
              </span>
            )}
          </div>
        ),
      },
      {
        Header: "ACTION",
        accessor: "actions",
        disableFilters: true,
        filterable: false,
        Cell: ({ row }) => (
          <div style={{ width: "150px", display: "flex" }}>
            {row?.original?.is_submitted == false ? (
              <div
                onClick={() => {
                  handleEditClick(row.original.id);
                }}
              >
                <Link className="me-3 text-primary">
                  <i className="mdi mdi-pencil font-size-18"></i>
                </Link>
              </div>
            ) : (
              <div style={{ visibility: "hidden" }}>
                <Link className="me-3 text-primary">
                  <i className="mdi mdi-pencil font-size-18"></i>
                </Link>
              </div>
            )}
            <div
              onClick={() => {
                handleViewClick(row.original.id);
              }}
            >
              <Link className="me-3 text-primary">
                <i className="mdi mdi-eye font-size-18"></i>
              </Link>
            </div>
          </div>
        ),
      },
    ],
    [page, pageSize]
  );

  const handleFileUpload = async (e) => {
    try {
      const file = e.target.files[0];

      const fileExtension = file.name.split(".").pop().toLowerCase();

      if (fileExtension !== "xlsx" && fileExtension !== "xls") {
        throw new Error("Please select a valid Excel file.");
      }

      setIsLoading(false);
      const projectId = JSON.parse(localStorage?.getItem("projectID"));
      const userDetails = JSON.parse(localStorage.getItem("userDetails")) || {};
      const createdBy = userDetails.id || null;

      const res = await uploadExelFile(
        "uploads",
        file,
        `/importInvoices?createdBy=${createdBy}&project_id=${projectId}`
      );
      setIsLoading(false);

      if (!res?.code && res?.message) {
        setPopupData({
          isOpen: true,
          message: res.message || "File imported successfully!",
          isError: false,
        });
        setSelectedFile(file);
      } else {
        setPopupData({
          isOpen: true,
          message: res?.message || "Error importing file. Please try again.",
          isError: true,
        });
      }
    } catch (error) {
      console.error("Upload error:", error);
      setIsLoading(false);

      const errorMessage =
        error?.message ||
        error?.Error ||
        "An error occurred while importing. Please try again.";

      setPopupData({
        isOpen: true,
        message: errorMessage,
        isError: true,
      });
    }

    setTimeout(() => {
      e.target.value = "";
    }, 0);
  };

  const closePopup = () => {
    setPopupData((prev) => ({ ...prev, isOpen: false }));
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <ModernPopup
          isOpen={popupData.isOpen}
          onClose={closePopup}
          message={popupData.message}
          isError={popupData.isError}
        />
        <Container fluid>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <Breadcrumb
              title="Invoice List"
              breadcrumbItems={breadcrumbItems}
            />
            <Button
              color="primary"
              className="waves-effect waves-light me-1"
              onClick={handleClickAdd}
              style={{ marginLeft: "auto", background: "#006eb9" }}
            >
              Create Invoice
            </Button>
            {/* <Button
              color="success"
              className="waves-effect waves-light me-1"
              onClick={() => document.getElementById("fileInput").click()}
            >
              Import
            </Button>
            <input
              type="file"
              id="fileInput"
              style={{ display: "none" }}
              accept=".xlsx, .xls"
              onChange={(e) => handleFileUpload(e)}
            /> */}
          </div>

          <Card>
            <CardBody>
              <TableContainer
                columns={columns || []}
                data={data || []}
                isPagination={false}
                // isGlobalFilter={false}
                iscustomPageSize={false}
                isBordered={false}
                customPageSize={10}
                isLoading={isLoading}
                onSearchInputData={getSearchInputData}
                pageIndexProp={page}
                onPageSizeChange={handlePageSizeChange}
                nextToPage={nextToPages}
                lastToPage={lastToPages}
                previousToPage={previousToPages}
                previousFirstToPage={previousFirstToPages}
                totalCount={totalCount}
                exportData={exportData}
                exportFileName={exportPageData?.fileName}
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default InvoicetList;
